/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fast_100msInputs */

const en_fast_100ms = /** @type {(inputs: Fast_100msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fast (100ms)`)
};

const es_fast_100ms = /** @type {(inputs: Fast_100msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rápido (100ms)`)
};

const fr_fast_100ms = /** @type {(inputs: Fast_100msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapide (100ms)`)
};

const de_fast_100ms = /** @type {(inputs: Fast_100msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnell (100ms)`)
};

const ja_fast_100ms = /** @type {(inputs: Fast_100msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`速い (100ms)`)
};

const zh_fast_100ms = /** @type {(inputs: Fast_100msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快 (100ms)`)
};

const ar_fast_100ms = /** @type {(inputs: Fast_100msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سريع (100ms)`)
};

const id_fast_100ms = /** @type {(inputs: Fast_100msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cepat (100ms)`)
};

const it_fast_100ms = /** @type {(inputs: Fast_100msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veloce (100ms)`)
};

const ru_fast_100ms = /** @type {(inputs: Fast_100msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Быстро (100мс)`)
};

const pt_fast_100ms = /** @type {(inputs: Fast_100msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rápido (100ms)`)
};

const ko_fast_100ms = /** @type {(inputs: Fast_100msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빠름 (100ms)`)
};

/**
* | output |
* | --- |
* | "Fast (100ms)" |
*
* @param {Fast_100msInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const fast_100ms = /** @type {((inputs?: Fast_100msInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fast_100msInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fast_100ms(inputs)
	if (locale === "es") return es_fast_100ms(inputs)
	if (locale === "fr") return fr_fast_100ms(inputs)
	if (locale === "de") return de_fast_100ms(inputs)
	if (locale === "ja") return ja_fast_100ms(inputs)
	if (locale === "zh") return zh_fast_100ms(inputs)
	if (locale === "ar") return ar_fast_100ms(inputs)
	if (locale === "id") return id_fast_100ms(inputs)
	if (locale === "it") return it_fast_100ms(inputs)
	if (locale === "ru") return ru_fast_100ms(inputs)
	if (locale === "pt") return pt_fast_100ms(inputs)
	return ko_fast_100ms(inputs)
});